const generateRamdomId = () => {
  let id = Math.floor(Math.random() * 10000);
  return id;
};

export { generateRamdomId };
